/* ============================================================
   línkè · FLIP 图片灯箱动画（2026-07-19 动效五件套②）
   纯 DOM、无 React：聊天灯箱和相册灯箱共用这份数学。
   flipIn：大图已渲染在最终位置 → 从 fromRect（被点的缩略图）
           反推初始 transform，下一帧松开 = 「从小图原地长大」。
   flipOut：反向，缩回 fromRect 后调 done（由调用方卸载节点）。
   调用方自己决定要不要跳过（reduce_motion / 没有 fromRect）。
   ============================================================ */

function delta(el, fromRect) {
  const to = el.getBoundingClientRect();
  if (!to.width || !to.height) return null;
  return {
    sx: fromRect.width / to.width,
    sy: fromRect.height / to.height,
    dx: fromRect.left + fromRect.width / 2 - (to.left + to.width / 2),
    dy: fromRect.top + fromRect.height / 2 - (to.top + to.height / 2),
  };
}

export function flipIn(el, fromRect, { duration = 0.32 } = {}) {
  if (!el || !fromRect) return;
  const play = () => {
    const d = delta(el, fromRect);
    if (!d) return;
    el.style.transition = 'none';
    el.style.transform = `translate(${d.dx}px, ${d.dy}px) scale(${d.sx}, ${d.sy})`;
    el.style.opacity = '0.55';
    // 双 rAF：先让初始 transform 落地渲染一帧，再开过渡，不然直接跳到终态
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        el.style.transition = `transform ${duration}s cubic-bezier(0.22, 0.61, 0.36, 1), opacity ${duration}s ease`;
        el.style.transform = 'none';
        el.style.opacity = '1';
      });
    });
  };
  // 图没解码完时最终盒子尺寸不可信，等 onload（data URI / 缓存图会立即 complete）
  if (el.complete && el.naturalWidth) play();
  else el.onload = play;
}

export function flipOut(el, fromRect, done, { duration = 0.26 } = {}) {
  if (!el || !fromRect) {
    done();
    return;
  }
  const d = delta(el, fromRect);
  if (!d) {
    done();
    return;
  }
  el.style.transition = `transform ${duration}s cubic-bezier(0.4, 0, 0.9, 0.6), opacity ${duration}s ease`;
  el.style.transform = `translate(${d.dx}px, ${d.dy}px) scale(${d.sx}, ${d.sy})`;
  el.style.opacity = '0.3';
  setTimeout(done, duration * 1000);
}
